export default class ButtonService {
    constructor(buttonEL, hiddenClass) {
    this.buttonEL = buttonEL;
    this.hiddenClass = hiddenClass;
    }

    hide() {
    this.buttonEL.classList.add(this.hiddenClass);
    }

    show() {
    this.buttonEL.classList.remove(this.hiddenClass);
    }

    disable() {
    this.buttonEL.disabled = true;
    }

    enable() {
    this.buttonEL.disabled = false;
    }
}